module.exports = __webpack_public_path__ + "img/scoreActive_01.ecfe6169.svg";